<div class="sasb-completion-dialog">
  <h2 mat-dialog-title>{{ data.title || 'Complete Order' }}</h2>

  <mat-dialog-content>
    <form [formGroup]="sasbForm" class="sasb-form">
      <div class="form-section">
        <mat-label class="section-title">SAS-B Requirement</mat-label>
        <mat-radio-group formControlName="sasbType" class="radio-group">
          <mat-radio-button value="required" class="radio-option">
            SAS-B Application
          </mat-radio-button>
          <mat-radio-button value="not-required" class="radio-option">
            No SAS-B Required
          </mat-radio-button>
        </mat-radio-group>
      </div>

      @if (showCheckboxes) {
      <div class="form-section">
        <mat-label class="section-title">SAS-B Requirements</mat-label>
        <div class="checkbox-group">
          <mat-checkbox formControlName="sasbApproved" class="checkbox-option">
            SAS-B Approved
          </mat-checkbox>
          <mat-checkbox formControlName="scriptIssued" class="checkbox-option">
            Script Issued
          </mat-checkbox>
          <mat-checkbox formControlName="medicalDirectorStored" class="checkbox-option">
            SAS-B Approval stored in Medical Director
          </mat-checkbox>
        </div>
      </div>
      }
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button type="button" (click)="onCancel()" class="cancel-button">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="onSubmit()"
      [disabled]="!sasbForm.valid"
      class="action-button"
      [class.complete-button]="buttonText === 'Complete'"
      [class.pause-button]="buttonText === 'Pause Appointment'"
    >
      {{ buttonText }}
    </button>
  </mat-dialog-actions>
</div>
